import { render, staticRenderFns } from "./PaymentTariffTypeEdit.vue?vue&type=template&id=4efe5ee4&lang=pug"
import script from "./PaymentTariffTypeEdit.vue?vue&type=script&lang=js"
export * from "./PaymentTariffTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports